// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"94b6fd7c","183":"f852f4e3","233":"410af564","453":"04c79a43","469":"ae6ad585","906":"0329a072","997":"6ecfa088"}[chunkId] + ".chunk.js";
};